module.exports = __webpack_public_path__ + "static/media/addIconSm.c901a19c.svg";